import axios from 'axios'
import {PaginateModel} from '../../../shared/models/PaginateModel'
import {BranchModel} from '../models/BranchModel'
import {CreateBranchModel} from '../models/CreateBranchModel'
import {BranchStatus} from '../constants'
import {cleanupPaginationParams} from '../../../shared/utils'

const API_URL = process.env.REACT_APP_API_URL
export const BRANCH_BASE_URL = `${API_URL}/branch`

export function getAllBranchesApi(params: PaginateModel) {
  return axios.get(`${BRANCH_BASE_URL}`, {
    params: cleanupPaginationParams(params),
  })
}

export function getAllUsersBranchesApi(params: PaginateModel) {
  return axios.get(`${BRANCH_BASE_URL}/users`, {
    params: cleanupPaginationParams(params),
  })
}
export function updateBranchApi(branchData: BranchModel) {
  return axios.put(`${BRANCH_BASE_URL}/${branchData.id}`, branchData)
}

export function updateBranchStatusApi(id: number, status: string, targetPersonInChargeId?: number, targetBranchId?: number) {
  const payload: any = {status}
  
  // Add targetPersonInChargeId only when status is ACTIVE and the field is provided
  if (status === BranchStatus.ACTIVE && targetPersonInChargeId) {
    payload.targetPersonInChargeId = targetPersonInChargeId
  }
  
  // Add targetBranchId only when status is INACTIVE and the field is provided
  if (status === BranchStatus.INACTIVE && targetBranchId) {
    payload.targetBranchId = targetBranchId
  }
  
  return axios.patch(`${BRANCH_BASE_URL}/${id}/status`, payload)
}

export const createBranchApi = async (data: CreateBranchModel) => {
  return await axios.post(`${BRANCH_BASE_URL}`, data)
}

export const createBranchUserApi = async (data: any) => {
  return await axios.post(`${BRANCH_BASE_URL}/users`, data)
}

export const updateBranchUserStatusApi = async (userIds: number[], status: string) => {
  return await axios.put(`${API_URL}/users/status`, { userIds, status })
}

export const deleteBranchUserApi = async (userId: number) => {
  return await axios.delete(`${BRANCH_BASE_URL}/users`, { data: { userId } })
}

export const updateBranchUserApi = async (data: {userId: number; firstName: string; lastName: string; password: string}) => {
  return await axios.patch(`${BRANCH_BASE_URL}/users`, data)
}
